import R from 'ramda';

const getPhoneNumber = R.pathOr('', [
  'activationModal',
  'phoneNumber',
  'phone',
]);

export default getPhoneNumber;
